/**
 * @owner @Appboy/core-objects
 */
import { customObjectsOnboardingStatus } from "../customObjectsOnboardingStatus/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsEnableAccounts = "/custom_objects/enable_accounts" as const;

/** A successful enable_accounts POST invalidates the onboarding_status GET so polling kicks off. */
export const customObjectsEnableAccountsCacheKeys: AllRouteEndpoints[] = [customObjectsOnboardingStatus];
